import { RootState } from '@store';

// Order
export const selectOrder = (state: RootState) => {
  return state.order?.order;
};

export const selectOrderId = (state: RootState) => {
  return state.order?.order?.id;
};

export const selectOrderStatus = (state: RootState) => {
  return selectOrder(state)?.status;
};

export const selectIsOrderRefetching = (state: RootState) => {
  return state.order?.isRefetching;
};

// Lead
export const selectOrderLead = (state: RootState) => {
  return selectOrder(state)?.lead;
};

export const selectLeadMake = (state: RootState) => {
  return selectOrderLead(state)?.make;
};

export const selectLeadModelSeries = (state: RootState) => {
  return selectOrderLead(state)?.modelSeries;
};

export const selectOrderType = (state: RootState) => {
  return selectOrderLead(state)?.orderType;
};

// Comments
export const selectOrderComments = (state: RootState) => {
  return selectOrder(state)?.comments;
};

// Vehicle
export const selectVehicle = (state: RootState) => {
  return selectOrder(state)?.vehicles?.[0];
};

export const selectSelectedSerialNumberFromOrder = (state: RootState) => {
  return selectVehicle(state)?.serialNo;
};

// Customer

export const selectOrderCustomer = (state: RootState) => {
  return selectOrder(state)?.customer;
};

export const selectOrderCustomerReference = (state: RootState) => {
  return selectOrderCustomer(state)?.reference;
};

export const selectOrderCustomerBosApiId = (state: RootState) => {
  return selectOrderCustomerReference(state)?.bosApiId;
};

// Events
export const selectOrderEvents = (state: RootState) => {
  return selectOrder(state)?.events;
};

// Vehicle Order Status
export const selectVehicleOrderStatusFromOrder = (state: RootState) => {
  return selectOrder(state)?.vehicleOrderStatus;
};

// Reserve Details
export const selectReserveDetailsFromOrder = (state: RootState) => {
  return selectOrder(state)?.reserveDetails;
};
